export enum UserRegisterMessages {
  titleCreate = "UserRegister.title.create",
  titleEdit = "UserRegister.title.edit",
  stepTabFormUser = "UserRegister.stepTab.formUser",
  stepTabAddUserToRoles = "UserRegister.stepTab.addUserToRoles",
  stepTabModuleAccess = "UserRegister.stepTab.moduleAccess",
  roleNotSelected = "UserRegister.roleNotSelected",
  roleNotFound = "UserRegister.roleNotFound",
  noRolesRegistered = "UserRegister.noRolesRegistered",
  confirmUserEditModalTitle = "UserRegister.confirmUserEditModalTitle",
  confirmUserEditModalDescription = "UserRegister.confirmUserEditModalDescription",
  confirmUserInactivateModalTitle = "UserRegister.confirmUserInactivateModalTitle",
  confirmUserInactivateModalDescription = "UserRegister.confirmUserInactivateModalDescription",
  moduleAccessTitle = "UserRegister.moduleAccess.title",
  moduleAccessCaption = "UserRegister.moduleAccess.caption",
  moduleAccessNoModules = "UserRegister.moduleAccess.noModules",
  moduleAccessSaveSuccess = "UserRegister.moduleAccess.saveSuccess",
  moduleAccessSaveError = "UserRegister.moduleAccess.saveError",
  moduleAccessNoChanges = "UserRegister.moduleAccess.noChanges",
  moduleAccessAdminNotice = "UserRegister.moduleAccess.adminNotice"
}

export interface TranslationUserRegisterMessages {
  [UserRegisterMessages.titleCreate] : string;
  [UserRegisterMessages.titleEdit] : string;
  [UserRegisterMessages.stepTabFormUser] : string;
  [UserRegisterMessages.stepTabAddUserToRoles] : string;
  [UserRegisterMessages.stepTabModuleAccess] : string;
  [UserRegisterMessages.roleNotSelected] : string;
  [UserRegisterMessages.roleNotFound] : string;
  [UserRegisterMessages.noRolesRegistered] : string;
  [UserRegisterMessages.confirmUserEditModalTitle] : string;
  [UserRegisterMessages.confirmUserEditModalDescription] : string;
  [UserRegisterMessages.confirmUserInactivateModalTitle] : string;
  [UserRegisterMessages.confirmUserInactivateModalDescription] : string;
  [UserRegisterMessages.moduleAccessTitle] : string;
  [UserRegisterMessages.moduleAccessCaption] : string;
  [UserRegisterMessages.moduleAccessNoModules] : string;
  [UserRegisterMessages.moduleAccessSaveSuccess] : string;
  [UserRegisterMessages.moduleAccessSaveError] : string;
  [UserRegisterMessages.moduleAccessNoChanges] : string;
  [UserRegisterMessages.moduleAccessAdminNotice] : string;
}
